import { ReactNode } from 'react'
import { Container, Content } from './styled'

interface IProps {
  shadow: boolean
  children: ReactNode
}

const Wrapper = ({ shadow, children }: IProps) => {
  return (
    <Container id="lmsPage">
      <Content shadow={shadow}>{children}</Content>
    </Container>
  )
}

export default Wrapper
